export default {
	'auth_login': 'Login',
	'error_page_btn_home': 'Go Homepage',
	'error_page_title': 'Page Not Found',
	'error_page_text': 'The page you\'re looking for couldn\'t be found. The address might be incorrect, or the page may have been deleted. Please try again or contact your administrator.',
};